import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getAllCafesLoading: false,
  getAllCafesFailed: false,
  getAllCafesReject: false,
  getAllCafesMessage: [],
  AllCafes: [],

  getCafeDetailsLoading: false,
  getCafeDetailsFailed: false,
  getCafeDetailsReject: false,
  getCafeDetailsMessage: [],
  cafeDetails: [],
  cafeMenu: [],
  cafeImages: [],
  cafeServices: [],
  commentData: [],

  searchCafesLoading: false,
  searchCafesFailed: false,
  searchCafesReject: false,
  searchCafesMessage: [],
  searchedCafes: [],
  searchedCafesTotalrecords: 0,
  hasMoreCafes: true,

  cafeNamesListLoading: false,
  cafeNamesListFailed: false,
  cafeNamesListReject: false,
  cafeNamesListMessage: [],
  cafeNamesList: [],

  getDynamicCafesByTypeLoading: false,
  getDynamicCafesByTypeFailed: false,
  getDynamicCafesByTypeReject: false,
  getDynamicCafesByTypeMessage: [],
  DynamicCafesByTypeList: [],
  DynamicCafesTitle: '',
  dynamicsHasMoreCafes: true,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_CAFES_LOADING: {
      return {
        ...state,
        getAllCafesLoading: true,
        getAllCafesFailed: false,
        getAllCafesReject: false,
        getAllCafesMessage: [],
        AllCafes: [],
      };
    }
    case actionTypes.GET_ALL_CAFES_SUCCESS: {
      return {
        ...state,
        getAllCafesLoading: false,
        getAllCafesFailed: false,
        getAllCafesReject: false,
        getAllCafesMessage: [],
        AllCafes: action.payload,
      };
    }
    case actionTypes.GET_ALL_CAFES_FAILED: {
      return {
        ...state,
        getAllCafesLoading: false,
        getAllCafesFailed: true,
        getAllCafesReject: false,
        getAllCafesMessage: [],
        AllCafes: [],
      };
    }
    case actionTypes.GET_ALL_CAFES_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getAllCafesLoading: false,
        getAllCafesFailed: false,
        getAllCafesReject: true,
        getAllCafesMessage: message,
        AllCafes: [],
      };
    }

    case actionTypes.GET_CAFE_DETAILS_LOADING: {
      return {
        ...state,
        getCafeDetailsLoading: true,
        getCafeDetailsFailed: false,
        getCafeDetailsReject: false,
        getCafeDetailsMessage: [],
        cafeDetails: [],
        cafeMenu: [],
        cafeImages: [],
        cafeServices: [],
        commentData: [],
      };
    }
    case actionTypes.GET_CAFE_DETAILS_SUCCESS: {
      return {
        ...state,
        getCafeDetailsLoading: false,
        getCafeDetailsFailed: false,
        getCafeDetailsReject: false,
        getCafeDetailsMessage: [],
        cafeDetails: action.payload,
        cafeMenu: action.payload.menus,
        cafeImages: action.payload.images,
        cafeServices: action.payload.services,
        commentData: action.payload.commentData,
      };
    }
    case actionTypes.GET_CAFE_DETAILS_FAILED: {
      return {
        ...state,
        getCafeDetailsLoading: false,
        getCafeDetailsFailed: true,
        getCafeDetailsReject: false,
        getCafeDetailsMessage: [],
        cafeDetails: [],
        cafeMenu: [],
        cafeImages: [],
        cafeServices: [],
        commentData: [],
      };
    }
    case actionTypes.GET_CAFE_DETAILS_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getCafeDetailsLoading: false,
        getCafeDetailsFailed: false,
        getCafeDetailsReject: true,
        getCafeDetailsMessage: message,
        cafeDetails: [],
        cafeMenu: [],
        cafeImages: [],
        cafeServices: [],
        commentData: [],
      };
    }

    case actionTypes.SEARCH_CAFES_LOADING: {
      return {
        ...state,
        searchCafesLoading: true,
        searchCafesFailed: false,
        searchCafesReject: false,
        searchCafesMessage: [],
        searchedCafes: [],
        searchedCafesTotalrecords: 0,
        hasMoreCafes: true,
      };
    }
    case actionTypes.SEARCH_CAFES_SUCCESS: {
      return {
        ...state,
        searchCafesLoading: false,
        searchCafesFailed: false,
        searchCafesReject: false,
        searchCafesMessage: [],
        searchedCafes: action.payload.cafes,
        searchedCafesTotalrecords: action.payload.totalRecords,
        hasMoreCafes: action.payload.hasMore,
      };
    }
    case actionTypes.SEARCH_CAFES_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        searchCafesLoading: false,
        searchCafesFailed: true,
        searchCafesReject: false,
        searchCafesMessage: message,
        searchedCafes: [],
        searchedCafesTotalrecords: 0,
        hasMoreCafes: true,
      };
    }
    case actionTypes.SEARCH_CAFES_REJECT: {
      return {
        ...state,
        searchCafesLoading: false,
        searchCafesFailed: false,
        searchCafesReject: true,
        searchCafesMessage: [],
        searchedCafes: [],
        searchedCafesTotalrecords: 0,
        hasMoreCafes: true,
      };
    }

    case actionTypes.CAFE_NAMES_LIST_AND_FILTER_LOADING: {
      return {
        ...state,
        cafeNamesListLoading: true,
        cafeNamesListFailed: false,
        cafeNamesListReject: false,
        cafeNamesListMessage: [],
        cafeNamesList: [],
      };
    }
    case actionTypes.CAFE_NAMES_LIST_AND_FILTER_SUCCESS: {
      return {
        ...state,
        cafeNamesListLoading: false,
        cafeNamesListFailed: false,
        cafeNamesListReject: false,
        cafeNamesListMessage: [],
        cafeNamesList: action.payload,
      };
    }
    case actionTypes.CAFE_NAMES_LIST_AND_FILTER_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        cafeNamesListLoading: false,
        cafeNamesListFailed: true,
        cafeNamesListReject: false,
        cafeNamesListMessage: message,
        cafeNamesList: [],
      };
    }
    case actionTypes.CAFE_NAMES_LIST_AND_FILTER_REJECT: {
      return {
        ...state,
        cafeNamesListLoading: false,
        cafeNamesListFailed: false,
        cafeNamesListReject: true,
        cafeNamesListMessage: [],
        cafeNamesList: [],
      };
    }

    case actionTypes.GET_DYNAMIC_CAFES_BY_TYPE_LOADING: {
      return {
        ...state,
        getDynamicCafesByTypeLoading: true,
        getDynamicCafesByTypeFailed: false,
        getDynamicCafesByTypeReject: false,
        getDynamicCafesByTypeMessage: [],
        dynamicCafesByTypeList: [],
        DynamicCafesTitle: '',
        dynamicsHasMoreCafes: false,
      };
    }
    case actionTypes.GET_DYNAMIC_CAFES_BY_TYPE_SUCCESS: {
      return {
        ...state,
        getDynamicCafesByTypeLoading: false,
        getDynamicCafesByTypeFailed: false,
        getDynamicCafesByTypeReject: false,
        getDynamicCafesByTypeMessage: [],
        dynamicCafesByTypeList: action.payload.items,
        DynamicCafesTitle: action.payload.title,
        dynamicsHasMoreCafes: action.payload.hasMore,
      };
    }
    case actionTypes.GET_DYNAMIC_CAFES_BY_TYPE_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getDynamicCafesByTypeLoading: false,
        getDynamicCafesByTypeFailed: true,
        getDynamicCafesByTypeReject: false,
        getDynamicCafesByTypeMessage: message,
        dynamicCafesByTypeList: [],
        dynamicsHasMoreCafes: false,

      };
    }
    case actionTypes.GET_DYNAMIC_CAFES_BY_TYPE_REJECT: {
      return {
        ...state,
        getDynamicCafesByTypeLoading: false,
        getDynamicCafesByTypeFailed: false,
        getDynamicCafesByTypeReject: true,
        getDynamicCafesByTypeMessage: [],
        dynamicCafesByTypeList: [],
        DynamicCafesTitle: '',
        dynamicsHasMoreCafes: false,
      };
    }

    default:
      return state;
  }
};
